'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * An extension to the bootstrap panel allowing it to be independently collapsable
 */
var Panel = function (_React$Component) {
	_inherits(Panel, _React$Component);

	function Panel(props) {
		_classCallCheck(this, Panel);

		var _this = _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));

		_this.state = {
			expanded: props.defaultExpanded
		};

		_this.toggle = _this.toggle.bind(_this);
		return _this;
	}

	_createClass(Panel, [{
		key: 'toggle',
		value: function toggle(ev) {
			var _props = this.props,
			    independent = _props.independent,
			    eventKey = _props.eventKey,
			    onSelect = _props.onSelect;

			var expanded = !this.isExpanded();
			if (independent) {
				// only `independent` panel uses state
				this.setState({ expanded: expanded }, function () {
					onSelect && onSelect(eventKey, ev);
				});
			} else if (onSelect) {
				onSelect(eventKey, ev);
			}

			var $bs_panelGroup = this.context.$bs_panelGroup;

			if ($bs_panelGroup) {
				// if the Panel is expanded, allow it to be collapsed
				$bs_panelGroup.onToggle(eventKey, expanded, ev);
			}
		}
	}, {
		key: 'isExpanded',
		value: function isExpanded() {
			var _props2 = this.props,
			    independent = _props2.independent,
			    eventKey = _props2.eventKey;
			var $bs_panelGroup = this.context.$bs_panelGroup;
			// If we have $bs_panelGroup it means someone is using this with
			// the newer Accordion/PanelGroup API. If that's the case then
			// get the expanded value by comparing the activeKey.

			if ($bs_panelGroup && !independent) {
				// if eventKey is passed as in the context allow the parent to control the state
				return $bs_panelGroup.activeKey === eventKey;
			} else if (independent) {
				// No matter what PanelGroup is being used, if the panel is
				// independent then use the value from the state.
				return this.state.expanded;
			} else {
				// The panel is controlled via expanded prop otherwise
				return this.props.expanded;
			}
		}
	}, {
		key: 'isCollapsible',
		value: function isCollapsible() {
			var _props3 = this.props,
			    independent = _props3.independent,
			    collapsible = _props3.collapsible;
			// `independent` panels or panels in a panel group infer that
			// the panel is collapsable

			if (this.context.$bs_panelGroup || independent) {
				return true;
			}
			return collapsible;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    children = _props4.children,
			    header = _props4.header,
			    className = _props4.className,
			    hasIcon = _props4.hasIcon,
			    iconCollapsed = _props4.iconCollapsed,
			    iconExpanded = _props4.iconExpanded,
			    footer = _props4.footer,
			    animate = _props4.animate,
			    borders = _props4.borders;

			var collapsible = this.isCollapsible();
			var expanded = this.isExpanded();
			var panelHeader = header;

			if (collapsible && header) {
				panelHeader = _react2.default.createElement(
					'div',
					{
						className: 'collapse-header panel-title',
						tabIndex: 0,
						onClick: this.toggle,
						onKeyPress: function onKeyPress(ev) {
							return (0, _accessibilityUtils.OnActionKey)(ev, _this2.toggle);
						}
					},
					_react2.default.createElement(
						'a',
						{ role: 'tab', 'aria-expanded': expanded, 'aria-selected': expanded },
						hasIcon && _react2.default.createElement('span', {
							key: 'header-icon',
							className: (0, _classnames2.default)('toggle-icon gg', _defineProperty({}, iconCollapsed, !expanded), _defineProperty({}, iconExpanded, expanded))
						}),
						header
					)
				);
			}
			// pass all the relevent props to the child bootstrap panel
			var props = _extends({}, this.props, {
				onToggle: /* istanbul ignore next */function onToggle() {}, // required with `expanded` prop
				className: (0, _classnames2.default)(className, 'axway-panel', {
					collapsible: collapsible,
					noanimate: !animate,
					noborders: !borders
				}),
				expanded: expanded
			});

			// Stop our props getting passed down into the bootstrap panel
			delete props.iconCollapsed;
			delete props.iconExpanded;
			delete props.independent;
			delete props.hasIcon;
			delete props.animate;
			delete props.borders;
			delete props.header;
			delete props.footer;
			delete props.collapsible;

			return _react2.default.createElement(
				_reactBootstrap.Panel,
				props,
				panelHeader && _react2.default.createElement(
					_reactBootstrap.Panel.Heading,
					null,
					panelHeader
				),
				_react2.default.createElement(
					_reactBootstrap.Panel.Body,
					{ collapsible: collapsible },
					children
				),
				footer && _react2.default.createElement(
					_reactBootstrap.Panel.Footer,
					null,
					footer
				)
			);
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			// Since we handle all the toggle work here, don't let the panel child
			// think it's inside a panelGroup by removing it from the child context
			return {
				$bs_panelGroup: null
			};
		}
	}]);

	return Panel;
}(_react2.default.Component);

Panel.childContextTypes = {
	$bs_panelGroup: _propTypes2.default.object
};

Panel.contextTypes = {
	$bs_panelGroup: _propTypes2.default.shape({
		onToggle: _propTypes2.default.func,
		activeKey: _propTypes2.default.string
	})
};

Panel.propTypes = {
	/**
  * Allows panels to be opened independently.
  */
	independent: _propTypes2.default.bool,
	iconCollapsed: _propTypes2.default.string,
	iconExpanded: _propTypes2.default.string,
	hasIcon: _propTypes2.default.bool,
	animate: _propTypes2.default.bool,
	borders: _propTypes2.default.bool,
	collapsible: _propTypes2.default.bool,
	expanded: _propTypes2.default.bool,
	header: _propTypes2.default.node,
	footer: _propTypes2.default.node,
	className: _propTypes2.default.string,
	eventKey: _propTypes2.default.any,
	defaultExpanded: _propTypes2.default.bool
};

Panel.defaultProps = _extends({}, _reactBootstrap.Panel.defaultProps, {
	independent: false,
	iconCollapsed: 'icon-GG-chevron-right',
	iconExpanded: 'icon-GG-chevron-down',
	hasIcon: false,
	animate: true,
	borders: true,
	defaultExpanded: false
});

var _default = Panel;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Panel, 'Panel', 'src/components/Panel.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Panel.jsx');
}();

;